import { useRef } from 'react';

// Third party
import { useSnackbar } from 'notistack';

// Hooks
import { useLogoutAPI } from './API/welcome';

// Components
import { TAxiosError } from '../types/responses';

const useError = () => {
  const { logout } = useLogoutAPI();
  const { enqueueSnackbar } = useSnackbar();

  const didLogout = useRef(false);

  const handleReqError = async (error: TAxiosError) => {
    const errorDetail = error.response?.data?.detail;
    const status = error?.response?.status;

    if (!didLogout.current && (status === 401 || status === 403)) {
      if (!localStorage.getItem('authToken')) return false;

      didLogout.current = true;
      enqueueSnackbar('Session expired. Please log in again.', { variant: 'warning' });
      await logout();
      return false;
    }

    if (status === 400 && errorDetail === 'A user with this email already exists.') {
      enqueueSnackbar('Serial already exists', { variant: 'error' });
      return false;
    }

    if (!didLogout.current) {
      didLogout.current = true;
      enqueueSnackbar('Something went wrong. Please try again later.', { variant: 'error' });
      await logout();
    }

    return false;
  };

  return {
    handleReqError,
  };
};

export { useError };